import React from 'react';
import { Route, Routes } from 'react-router-dom';
import BudgetsListPage from './BudgetsListPage';

export default function BudgetsRoutes() {
  return (
    <Routes>
      <Route index element={<BudgetsListPage />} />
    </Routes>
  );
}
